export default "__VITE_ASSET__8ce0a292__"